const EUR_COUNTRIES = new Set([
    'AT', 'BE', 'HR', 'CY', 'FI', 'FR', 'DE', 'GR', 'IE',
    'IT', 'LV', 'LT', 'NL', 'PT', 'SK', 'SI', 'ES', 'CZ', 'HU',
    'PL', 'RO', 'BG', 'SE', 'DK', 'NO', 'IS', 'RS', 'MK', 'MD',
    'EE', 'LU', 'MT', 'AD', 'MC', 'SM', 'VA', 'ME', 'XK', 'BA', 'AL',
]);

export const getRegion = (country: string): string | null => {
    if (country === 'GB') return 'gbp';
    if (EUR_COUNTRIES.has(country)) return 'eur';
    return null;
};